class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', event => { if (event.code === 'Escape') this.close(); });
    // El overlay se reemplaza al renderizar; este listener permanece en el componente.
    this.addEventListener('click', event => { if (event.target.id === 'CartDrawer-Overlay') this.close(); });
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const link = document.querySelector('#cart-icon-bubble');
    if (!link) return;
    link.setAttribute('role', 'button');
    link.setAttribute('aria-haspopup', 'dialog');
    link.addEventListener('click', event => { event.preventDefault(); this.open(link); });
    link.addEventListener('keydown', event => {
      if (event.code === 'Space') { event.preventDefault(); this.open(link); }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    this.classList.add('animate', 'active');
    document.body.classList.add('overflow-hidden');
    requestAnimationFrame(() => {
      const container = this.querySelector('.drawer__inner');
      if (container && this.classList.contains('active')) trapFocus(container, container);
    });
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement?.isConnected ? this.activeElement : document.querySelector('#cart-icon-bubble'));
    document.body.classList.remove('overflow-hidden');
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    // Las secciones del add pueden preceder al recálculo de urgencia. Leer el estado final.
    return window.tematikCart.refresh().catch(() => {}).finally(() => this.open());
  }

  getSectionsToRender() {
    return [{ id: 'cart-drawer', selector: '#CartDrawer' }, { id: 'cart-icon-bubble' }];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return this.getSectionDOM(html, selector)?.innerHTML || '';
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return typeof html === 'string' ? new DOMParser().parseFromString(html, 'text/html').querySelector(selector) : null;
  }

  setActiveElement(element) { this.activeElement = element; }
}
if (!customElements.get('cart-drawer')) customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  onCartUpdate() { return window.tematikCart.refresh(); }
  getSectionsToRender() {
    return [
      { id: 'CartDrawer', section: 'cart-drawer', selector: '#CartDrawer' },
      { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' }
    ];
  }
}
if (!customElements.get('cart-drawer-items')) customElements.define('cart-drawer-items', CartDrawerItems);

(() => {
  const cache = new Map();
  let previousTotal = null;

  function productURL(value) {
    try {
      const url = new URL(value, window.location.origin);
      if (url.origin === window.location.origin && url.pathname.includes('/products/')) return url.href;
    } catch (_) {}
    return null;
  }

  async function recommendations(cart) {
    const container = document.getElementById('CartDrawer-UpsellProducts');
    if (!container) return;
    const ids = [...new Set(cart.items.filter(item => Number(item.variant_id) !== 44707009527853).map(item => item.product_id))];
    if (!ids.length) return;
    const key = ids.slice().sort().join(',');
    try {
      let products = cache.get(key);
      if (!products) {
        const url = new URL((window.Shopify?.routes?.root || '/') + 'recommendations/products.json', window.location.origin);
        url.search = new URLSearchParams({ product_id: ids[0], limit: 6, intent: 'related' });
        const response = await fetch(url, { credentials: 'same-origin' });
        if (!response.ok) throw new Error('Recomendaciones no disponibles');
        const data = await response.json();
        products = (data.products || []).filter(product => !ids.includes(product.id) && product.available && productURL(product.url)).slice(0, 1);
        cache.set(key, products);
      }
      if (!container.isConnected) return;
      container.replaceChildren();
      container.closest('.cart-upsell').hidden = !products.length;
      products.forEach(product => {
        const card = document.createElement('div');
        card.className = 'cart-upsell__card';
        const link = document.createElement('a');
        link.className = 'cart-upsell__img-link';
        link.href = productURL(product.url);
        if (product.featured_image) {
          const url = new URL(product.featured_image, window.location.origin);
          if (url.protocol === 'https:' || url.protocol === 'http:') {
            const image = document.createElement('img');
            url.searchParams.set('width', '140');
            image.src = url.href;
            url.searchParams.set('width', '280');
            image.srcset = image.src + ' 140w, ' + url.href + ' 280w';
            image.sizes = '70px';
            image.alt = product.title;
            image.loading = 'lazy';
            image.width = 70;
            image.height = 70;
            link.append(image);
          }
        }
        const info = document.createElement('div');
        info.className = 'cart-upsell__info';
        const title = document.createElement('a');
        title.className = 'cart-upsell__title';
        title.href = link.href;
        title.textContent = product.title;
        const price = document.createElement('span');
        price.className = 'cart-upsell__price';
        price.textContent = product.handle === 'papel-tapiz-vinilo' ? 'Calculá el precio para tu pared'
          : product.price > 0 ? (product.price_varies ? 'Desde ' : '') + '$' + (product.price / 100).toLocaleString('es-UY')
          : 'Consultá el precio';
        const choose = document.createElement('a');
        choose.className = 'cart-upsell__choose';
        choose.href = link.href;
        choose.textContent = 'Elegir opciones';
        // La API de recomendaciones no informa requisitos de personalización: siempre abrir la ficha.
        info.append(title, price, choose);
        card.append(link, info);
        container.append(card);
      });
    } catch (_) {
      if (container.isConnected) container.closest('.cart-upsell').hidden = true;
    }
  }

  function rewards(cart) {
    const total = cart.items_subtotal_price;
    const thresholds = [500000, 1000000, 2000000];
    document.querySelectorAll('.cart-rewards-bar').forEach(bar => {
      const next = thresholds.find(value => value > total);
      bar.dataset.proximity = next && next - total <= next * 0.1 ? 'very-near' : next && next - total <= next * 0.2 ? 'near' : 'far';
      bar.classList.toggle('cart-rewards-bar--complete', total >= thresholds[2]);
      bar.querySelectorAll('.cart-rewards__milestone-dot').forEach((dot, index) => {
        if (previousTotal !== null && previousTotal < thresholds[index] && total >= thresholds[index]) {
          dot.classList.add('cart-rewards__milestone-dot--just-reached');
          if (bar.closest('cart-drawer.active') && typeof window.confetti === 'function') {
            window.confetti({ particleCount: 45, spread: 70, zIndex: 99999, disableForReducedMotion: true });
          }
        }
      });
    });
    previousTotal = total;
  }

  document.addEventListener('tematik:cart:rendered', event => {
    recommendations(event.detail.cart);
    rewards(event.detail.cart);
  });
})();
